import { loginRoutes } from './login/routes'
import { customizadoRoutes } from './customizado/routes'
import { mercadoRoutes } from './mercado/routes'
import { serieRoutes } from './serie/routes'
import { registroRoutes } from './registro/routes'
import { instituicaoRoutes } from './instituicao/routes'
import { dashboardRoutes } from './dashboard/routes'
import { lancamentoRoutes } from './lancamento/routes'
import { dashboardDinamicoRoutes } from './dashboard-dinamico/routes'
import { configDashboardRoutes } from './config-dashboard/routes'

const rootRoutes = [
  ...dashboardRoutes,
  ...configDashboardRoutes,
  ...customizadoRoutes,
  ...mercadoRoutes,
  ...serieRoutes,
  ...lancamentoRoutes,
  ...dashboardDinamicoRoutes
]

const noLayoutRoutes = [...registroRoutes, ...instituicaoRoutes, ...loginRoutes]

export { noLayoutRoutes, rootRoutes }
